import { Settings, Users } from "lucide-react";

export function CategoryIcon({ icon }: { icon: string }) {
	switch (icon) {
		case "handshake":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
				>
					<g
						fill="none"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
					>
						<path d="m11 17l2 2a1 1 0 1 0 3-3" />
						<path d="m14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
						<path d="m21 3l1 11h-2M3 3L2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8" />
					</g>
				</svg>
			);
		case "settings":
			return <Settings className="h-6 w-6" />;
		case "users":
			return <Users className="h-6 w-6" />;
		default:
			return null;
	}
}
